module.exports = __webpack_public_path__ + "static/img/background.62e75f46.svg";